import React, { Component } from 'react';
import 'react-phone-input-2/lib/style.css';
import { Modal, Form, Button } from 'react-bootstrap';

export default class SendGroupToLMS extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        const { groupId, sendGroupToLMS } = this.props;
        
        return (
            <Modal show={this.props.showModal} onHide={this.props.hideModal} className="commonModal modalAlert">
                <Modal.Header closeButton>
                    <Modal.Title id="example-custom-modal-styling-title">
                        <h5>Send Group to TLMS</h5>
                        <p>Creating this group in TLMS.</p>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>

                <div class="noteSection">
                    <p><b>Please Note:</b> The following members in this group must be present in TLMS. The group will be created in TLMS only with the members who are found in TLMS. 
                    <br></br><br></br>
                    <b>Ensure that all required members exist in TLMS before proceeding.</b>
                    </p>
                 </div>
                        
                        
                    
                </Modal.Body>
                <Modal.Footer>
                    <Button className='btn closeBtn' onClick={this.props.hideModal}>Close</Button>
                    <Button className='btn btn-primary' onClick={() => {sendGroupToLMS(groupId); this.props.hideModal()}}>Send to LMS</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}
